module.exports = __webpack_public_path__ + "img/Tom Whatley.6bb21b8f.jpg";